var _style, _defs, _rect, _rect2, _rect3, _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBanderaCol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 275.44 173.84",
    style: {
      enableBackground: "new 0 0 275.44 173.84"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000047743035281961543870000000272197038379518397_);}\n\t.st1{fill:#FFED00;}\n\t.st2{fill:#2D31FA;}\n\t.st3{fill:#E30613;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M242.46,158.06H32.98c-9.07,0-16.42-7.35-16.42-16.42V32.19c0-9.07,7.35-16.42,16.42-16.42h209.48 c9.07,0,16.42,7.35,16.42,16.42v109.45C258.88,150.71,251.53,158.06,242.46,158.06z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070816108050559183910000000966669825879119521_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000070816108050559183910000000966669825879119521_)"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.56,
    y: 15.78,
    className: "st1",
    width: 242.32,
    height: 66
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.56,
    y: 81.77,
    className: "st2",
    width: 242.32,
    height: 38.15
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.56,
    y: 119.92,
    className: "st3",
    width: 242.32,
    height: 38.15
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanderaCol);
export default __webpack_public_path__ + "static/media/bandera_col.caf9b140f4320a6de6bfce75a22f7103.svg";
export { ForwardRef as ReactComponent };